var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0599 14.3334C14.0599 14.52 13.9133 14.6667 13.7266 14.6667H2.27327C2.08661 14.6667 1.93994 14.52 1.93994 14.3334C1.93994 11.5734 4.65994 9.33337 7.99994 9.33337C8.68661 9.33337 9.35328 9.42669 9.96661 9.60669C9.57328 10.0734 9.33327 10.68 9.33327 11.3334C9.33327 11.8334 9.47326 12.3067 9.71993 12.7067C9.85326 12.9334 10.0266 13.14 10.2266 13.3134C10.6933 13.74 11.3133 14 11.9999 14C12.7466 14 13.4199 13.6934 13.8999 13.2C14.0066 13.56 14.0599 13.94 14.0599 14.3334Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00008 8.00004C9.84103 8.00004 11.3334 6.50766 11.3334 4.66671C11.3334 2.82576 9.84103 1.33337 8.00008 1.33337C6.15913 1.33337 4.66675 2.82576 4.66675 4.66671C4.66675 6.50766 6.15913 8.00004 8.00008 8.00004Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.47 7.83002C14.75 7.01002 13.68 6.5 12.5 6.5C11.38 6.5 10.36 6.96002 9.63 7.71002C8.93 8.43002 8.5 9.42 8.5 10.5C8.5 11.25 8.70999 11.96 9.07999 12.56C9.27999 12.9 9.54 13.21 9.84 13.47C10.54 14.11 11.47 14.5 12.5 14.5C13.96 14.5 15.23 13.72 15.92 12.56C16.13 12.22 16.29 11.83 16.38 11.43C16.46 11.13 16.5 10.82 16.5 10.5C16.5 9.48 16.11 8.54002 15.47 7.83002ZM14 11.23H13.25V12.01C13.25 12.42 12.91 12.76 12.5 12.76C12.09 12.76 11.75 12.42 11.75 12.01V11.23H11C10.59 11.23 10.25 10.89 10.25 10.48C10.25 10.07 10.59 9.72998 11 9.72998H11.75V9.02002C11.75 8.61002 12.09 8.27002 12.5 8.27002C12.91 8.27002 13.25 8.61002 13.25 9.02002V9.72998H14C14.41 9.72998 14.75 10.07 14.75 10.48C14.75 10.89 14.41 11.23 14 11.23Z",
    fill: "#29CD3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/add-user.9db86941e3cdd496bdf1cdcc6c7a1b08.svg";
export { ForwardRef as ReactComponent };